import React from 'react';
import SelexMathNavbar from "./CommonC/SelexMathNavbar";


function SelexFCC() {
  return (
    <div>
       <SelexMathNavbar />

         <iframe
      src="/SelexFCC.html"
      width="100%"
      height="800px"
      style={{ border: "none" }}
      title="HTML Page"
    />
    </div>
  )
}

export default SelexFCC